// Localized market configs for AppFillip per-country homepages.
// Each config drives SEO meta, Hero copy, currency, case studies emphasis and local testimonials.

export const MARKETS_CONFIG = {
  us: {
    code: "us",
    name: "United States",
    flag: "🇺🇸",
    shortName: "USA",
    locale: "en_US",
    currency: "$",
    multiplier: 1,
    keyword: "App Marketing Agency USA",
    metaTitle:
      "App Marketing Agency USA — Full-Stack iOS & Android Growth in the United States | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for USA iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — built for the US App Store and Google Play. Free growth audit for US founders.",
    keywords:
      "app marketing agency USA, mobile app marketing USA, ASO agency USA, user acquisition agency USA, app growth agency United States, iOS marketing USA, Google Play marketing USA, app marketing San Francisco, app marketing New York, US app growth partner",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "US founders trust to take iOS & Android apps from launch to category leader.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for USA iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. From Silicon Valley startups to NYC FinTechs — six growth levers, one US team, 40+ apps shipped to the top.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 40+ US app founders · California → New York · $100B+ app economy",
    verticalFocus: ["Gaming", "FinTech", "Health"],
    localStat: { value: "40+", label: "US apps ranked" },
    testimonial: {
      name: "Daniel Brooks",
      role: "CEO · Skydeck (San Francisco, CA)",
      text: "AppFillip cracked the US App Store algorithm for us. We went from page 4 to Top 20 in Productivity within 11 weeks. Best agency hire we've made.",
    },
    caseStudyFocus: "casual-game-global-expansion",
  },
  uk: {
    code: "uk",
    name: "United Kingdom",
    flag: "🇬🇧",
    shortName: "UK",
    locale: "en_GB",
    currency: "£",
    multiplier: 0.8,
    keyword: "App Marketing Agency UK",
    metaTitle:
      "App Marketing Agency UK — Full-Stack iOS & Android Growth in the United Kingdom | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for UK iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — built for the UK App Store, Google Play and every paid channel. Free growth audit for British founders.",
    keywords:
      "app marketing agency UK, mobile app marketing UK, ASO agency UK, user acquisition agency United Kingdom, app growth agency London, iOS marketing UK, Google Play marketing UK, FinTech app marketing UK",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "UK SaaS and FinTech founders trust to take iOS & Android apps from launch to category leader.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for UK iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. From London FinTechs to Manchester SaaS — six growth levers, one British team, 22+ apps shipped to the top.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 22+ UK app founders · London → Manchester · Premium CPIs",
    verticalFocus: ["FinTech", "SaaS", "Health"],
    localStat: { value: "22+", label: "UK apps ranked" },
    testimonial: {
      name: "Amelia Carter",
      role: "Head of Growth · Halo Health (London)",
      text: "AppFillip understands the UK App Store better than any agency we've worked with. Our conversion on the British store jumped 58% in two months.",
    },
    caseStudyFocus: "kids-education-app-organic",
  },
  au: {
    code: "au",
    name: "Australia",
    flag: "🇦🇺",
    shortName: "Australia",
    locale: "en_AU",
    currency: "A$",
    multiplier: 1.55,
    keyword: "App Marketing Agency Australia",
    metaTitle:
      "App Marketing Agency Australia — Full-Stack iOS & Android Growth | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for Australian iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — tuned for the AU App Store, Google Play, and every paid channel. Free growth audit for AU founders.",
    keywords:
      "app marketing agency Australia, mobile app marketing Sydney, ASO agency Australia, user acquisition agency Australia, app growth agency Melbourne, iOS marketing Australia, Google Play marketing AU",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "Australian founders trust for fast category-leading wins on iOS & Android.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for Australian iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. Less competition than the US, faster wins, same six-lever playbook from Sydney to Brisbane.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 14+ AU app founders · Sydney → Melbourne → Brisbane",
    verticalFocus: ["Travel", "Health", "eCommerce"],
    localStat: { value: "14+", label: "AU apps ranked" },
    testimonial: {
      name: "Liam O'Connor",
      role: "Founder · Voyage (Sydney)",
      text: "We hit Top 20 Travel in Australia within six weeks of starting with AppFillip. Their keyword work for the AU market is surgical.",
    },
    caseStudyFocus: "kids-education-app-organic",
  },
  uae: {
    code: "uae",
    name: "UAE",
    flag: "🇦🇪",
    shortName: "UAE",
    locale: "en_AE",
    currency: "AED ",
    multiplier: 3.67,
    keyword: "App Marketing Agency UAE",
    metaTitle:
      "App Marketing Agency UAE — Full-Stack Dubai & Abu Dhabi App Growth | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for UAE iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — Arabic + English, optimized for App Store, Google Play, Meta, TikTok and Apple Search Ads. Free growth audit for UAE founders.",
    keywords:
      "app marketing agency UAE, mobile app marketing Dubai, ASO Dubai, user acquisition Abu Dhabi, Arabic app marketing, Middle East app agency, app growth UAE, iOS marketing Dubai",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "UAE founders trust for Arabic + English app growth across iOS & Android.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for UAE iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. Arabic-first keyword strategy, Dubai and Abu Dhabi market intelligence, six growth levers, one regional team.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 18+ UAE app founders · Dubai → Abu Dhabi · Arabic + English",
    verticalFocus: ["Gaming", "Retail", "FinTech"],
    localStat: { value: "18+", label: "UAE apps ranked" },
    testimonial: {
      name: "Omar Al-Farsi",
      role: "Founder · PaySprint (Dubai)",
      text: "AppFillip moved our neo-bank from rank #38 to #2 on Google Play UAE in 90 days. No one else understood the Arabic + English dual-keyword play like they do.",
    },
    caseStudyFocus: "investment-app-global-aso",
  },
  ca: {
    code: "ca",
    name: "Canada",
    flag: "🇨🇦",
    shortName: "Canada",
    locale: "en_CA",
    currency: "C$",
    multiplier: 1.36,
    keyword: "App Marketing Agency Canada",
    metaTitle:
      "App Marketing Agency Canada — Bilingual EN + FR Full-Stack iOS & Android Growth | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for Canadian iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — bilingual English + French, optimized for the CA App Store, Google Play, Meta, TikTok and Apple Search Ads.",
    keywords:
      "app marketing agency Canada, mobile app marketing Toronto, ASO agency Canada, user acquisition Canada, French app marketing Montreal, bilingual app agency, iOS marketing Canada, app growth Vancouver",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "Canadian founders trust for bilingual EN + FR iOS & Android growth.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for Canadian iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. From Toronto English-first to Montreal French-first — six growth levers, one bilingual team.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 11+ CA app founders · Toronto → Montreal → Vancouver · EN + FR",
    verticalFocus: ["FinTech", "Health", "eCommerce"],
    localStat: { value: "11+", label: "CA apps ranked" },
    testimonial: {
      name: "Sophie Tremblay",
      role: "CMO · MapleFin (Montreal)",
      text: "Finally an ASO agency that speaks both our markets. AppFillip's bilingual keyword strategy lifted our Quebec installs 3x in one quarter.",
    },
    caseStudyFocus: "casual-game-global-expansion",
  },
  de: {
    code: "de",
    name: "Germany",
    flag: "🇩🇪",
    shortName: "Germany",
    locale: "de_DE",
    currency: "€",
    multiplier: 0.93,
    keyword: "App-Marketing-Agentur Deutschland",
    metaTitle:
      "App-Marketing-Agentur Deutschland — Full-Stack iOS & Android Wachstum | AppFillip",
    metaDescription:
      "AppFillip ist die Full-Stack-App-Marketing-Agentur für deutsche iOS & Android Apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — optimiert für App Store und Google Play.",
    keywords:
      "App-Marketing-Agentur Deutschland, ASO Agentur Deutschland, User Acquisition Deutschland, App-Wachstum Berlin, deutsche App-Marketing-Agentur, app marketing agency Germany",
    h1Title: "Die",
    h1Accent: "App-Marketing-Agentur",
    h1Tail: "der deutsche Gründer vertrauen, um iOS & Android Apps zur Kategorie-Spitze zu führen.",
    heroSubtitle:
      "AppFillip ist die Full-Stack-App-Marketing-Agentur für deutsche iOS & Android Apps. Wir ranken, akquirieren, konvertieren und halten — über App Store, Google Play, Meta, TikTok, Apple Search Ads und Google App Campaigns. Von Berlin bis München — sechs Wachstumshebel, ein Team.",
    marketEmphasis: "Full-Stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Von 9+ deutschen App-Gründern gewählt · Berlin → München → Hamburg",
    verticalFocus: ["FinTech", "Health", "Produktivität"],
    localStat: { value: "9+", label: "DE Apps gerankt" },
    editionNotice: {
      label: "Sie sehen die Deutschland-Edition · für deutsche App-Gründer lokalisiert",
      switchLabel: "Global",
    },
    testimonial: {
      name: "Lukas Weber",
      role: "Gründer · Kindred (Berlin)",
      text: "AppFillip ist die einzige Agentur, die die deutsche App-Store-Optimierung wirklich versteht. Platz 1 in der Health-Kategorie innerhalb von 60 Tagen.",
    },
    caseStudyFocus: "kids-education-app-organic",
  },
  jp: {
    code: "jp",
    name: "Japan",
    flag: "🇯🇵",
    shortName: "Japan",
    locale: "ja_JP",
    currency: "¥",
    multiplier: 150,
    keyword: "アプリマーケティングエージェンシー 日本",
    metaTitle:
      "日本のアプリマーケティングエージェンシー — iOS・Androidの本格グロース支援 | AppFillip",
    metaDescription:
      "AppFillipは、日本のiOS・Androidアプリ向けフルスタック・アプリマーケティングエージェンシーです。ASO・ユーザー獲得・インフルエンサー・リテンション・クリエイティブ・分析を、App StoreとGoogle Play向けに最適化。日本の創業者向けに無料グロース監査を提供。",
    keywords:
      "アプリマーケティング 日本, アプリマーケティングエージェンシー, ASO 日本, ユーザー獲得 日本, アプリ集客 東京, iOSマーケティング 日本, Google Play マーケティング 日本, app marketing agency Japan, ASO agency Japan, mobile app growth Japan",
    h1Title: "日本の",
    h1Accent: "アプリマーケティングエージェンシー",
    h1Tail: "iOS・Androidアプリをローンチからカテゴリーリーダーへ導きます。",
    heroSubtitle:
      "AppFillipは、日本のiOS・Androidアプリのためのフルスタック・アプリマーケティングエージェンシーです。ASO、ユーザー獲得、インフルエンサー、リテンション、クリエイティブ、分析の6つのレバーで、App Store・Google Play・Meta・TikTok・Apple Search Ads・Google App Campaignsを横断的に最適化。世界第2位のiOS収益市場で、日本語ネイティブのキーワード戦略とローカライズを提供します。",
    marketEmphasis: "フルスタック：ASO・UA・インフルエンサー・リテンション・クリエイティブ・分析",
    trustBadge: "日本の7社以上のアプリ創業者が選択 · 東京 → 大阪 · 世界第2位のiOS収益市場",
    verticalFocus: ["ゲーム", "マンガ", "プロダクティビティ"],
    localStat: { value: "7+", label: "日本のアプリをランクイン" },
    editionNotice: {
      label: "日本版をご覧いただいています · 日本のアプリ創業者向けにローカライズ済み",
      switchLabel: "グローバル",
    },
    testimonial: {
      name: "佐藤 春樹",
      role: "創業者 · LoopQuest JP（東京）",
      text: "AppFillipは、Google翻訳ではなく本物の日本語ASOの専門知識をもたらしてくれました。iOS収益は1四半期で2倍になりました。",
    },
    caseStudyFocus: "casual-game-global-expansion",
  },
  sg: {
    code: "sg",
    name: "Singapore",
    flag: "🇸🇬",
    shortName: "Singapore",
    locale: "en_SG",
    currency: "S$",
    multiplier: 1.35,
    keyword: "App Marketing Agency Singapore",
    metaTitle:
      "App Marketing Agency Singapore — Full-Stack iOS & Android Growth in SEA | AppFillip",
    metaDescription:
      "AppFillip is the full-stack app marketing agency for Singapore and Southeast Asia iOS & Android apps. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — bilingual EN + CN, optimized for App Store, Google Play, Meta, TikTok and Apple Search Ads.",
    keywords:
      "app marketing agency Singapore, mobile app marketing SEA, ASO agency Singapore, user acquisition Singapore, B2B app marketing, Chinese app marketing, iOS marketing Singapore, app growth SEA",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "Singapore and Southeast Asia founders trust for EN + CN iOS & Android growth.",
    heroSubtitle:
      "AppFillip is a full-stack app marketing agency for Singapore and SEA iOS & Android apps. We rank, acquire, convert and retain — across the App Store, Google Play, Meta, TikTok, Apple Search Ads and Google App Campaigns. Strong B2B and FinTech track record across English and Chinese keyword universes.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 8+ SG app founders · Orchard → Tanjong Pagar · EN + CN",
    verticalFocus: ["B2B", "FinTech", "Productivity"],
    localStat: { value: "8+", label: "SG apps ranked" },
    testimonial: {
      name: "Mei Lin",
      role: "CEO · FinKart (Singapore)",
      text: "AppFillip's bilingual EN + CN keyword work unlocked our SEA expansion. Singapore App Store Top 5 in Finance within 10 weeks.",
    },
    caseStudyFocus: "investment-app-global-aso",
  },
  br: {
    code: "br",
    name: "Brazil",
    flag: "🇧🇷",
    shortName: "Brazil",
    locale: "pt_BR",
    currency: "R$",
    multiplier: 5.1,
    keyword: "Agência de Marketing de Apps Brasil",
    metaTitle:
      "Agência de Marketing de Apps Brasil — Crescimento Full-Stack iOS e Android | AppFillip",
    metaDescription:
      "AppFillip é a agência de marketing de apps full-stack para apps iOS e Android no Brasil. ASO, aquisição de usuários, influenciadores, retenção, criativo e analytics — otimizado para App Store, Google Play, Meta, TikTok e Apple Search Ads. Auditoria de crescimento gratuita.",
    keywords:
      "agência de marketing de apps Brasil, marketing de aplicativos São Paulo, ASO Brasil, aquisição de usuários Brasil, agência app Rio, marketing iOS Brasil, app marketing agency Brazil",
    h1Title: "A",
    h1Accent: "Agência de Marketing de Apps",
    h1Tail: "que fundadores brasileiros escolhem para levar apps iOS e Android ao topo da categoria.",
    heroSubtitle:
      "AppFillip é a agência full-stack de marketing de apps para apps iOS e Android no Brasil. Posicionamos, adquirimos, convertemos e retemos — em App Store, Google Play, Meta, TikTok, Apple Search Ads e Google App Campaigns. De São Paulo ao Rio — seis alavancas de crescimento, um time, estratégia de palavras-chave em português.",
    marketEmphasis: "Full-stack: ASO · UA · Influenciadores · Retenção · Criativo · Analytics",
    trustBadge: "Atendendo 6+ fundadores brasileiros · São Paulo → Rio · Maior mercado da América Latina",
    verticalFocus: ["Gaming", "FinTech", "eCommerce"],
    localStat: { value: "6+", label: "Apps brasileiros classificados" },
    editionNotice: {
      label: "Você está vendo a edição Brasil · localizada para fundadores brasileiros de apps",
      switchLabel: "Global",
    },
    testimonial: {
      name: "Rafael Costa",
      role: "Fundador · PlayLoop BR (São Paulo)",
      text: "AppFillip trouxe ASO de verdade para o Brasil. Nosso app de jogos chegou ao Top 10 Casual da App Store BR em 75 dias.",
    },
    caseStudyFocus: "casual-game-global-expansion",
  },
  in: {
    code: "in",
    name: "India",
    flag: "🇮🇳",
    shortName: "India",
    locale: "en_IN",
    currency: "₹",
    multiplier: 84,
    keyword: "App Marketing Agency India",
    metaTitle:
      "App Marketing Agency India — Full-Stack iOS & Android Growth Built in Jaipur | AppFillip",
    metaDescription:
      "AppFillip is India's #1 full-stack app marketing agency, headquartered in Jaipur. ASO, User Acquisition, Influencer, Retention, Creative & Analytics — Hindi + English, optimized for Google Play India, Apple App Store, Meta, TikTok and Apple Search Ads. Free growth audit for Indian founders.",
    keywords:
      "app marketing agency India, mobile app marketing Mumbai, ASO agency India, user acquisition India, app growth agency Bangalore, Hindi app marketing, iOS marketing India, Google Play marketing India, app marketing Jaipur, Indian app agency",
    h1Title: "The",
    h1Accent: "App Marketing Agency",
    h1Tail: "Indian founders trust to take iOS & Android apps from launch to category leader — built in Jaipur, shipping #1 ranks nationwide.",
    heroSubtitle:
      "AppFillip is India's #1 full-stack app marketing agency. We rank, acquire, convert and retain Indian iOS & Android apps — across Google Play India, the Apple App Store, Meta, TikTok, Apple Search Ads and Google App Campaigns. Hindi and English keyword strategy tuned for Tier 1, 2 and 3 cities. Six growth levers, one Indian team, 35+ apps shipped to the top.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retention · Creative · Analytics",
    trustBadge: "Serving 35+ Indian app founders · Mumbai → Bangalore → Delhi → Jaipur",
    verticalFocus: ["EdTech", "FinTech", "Gaming"],
    localStat: { value: "35+", label: "IN apps ranked" },
    testimonial: {
      name: "Priya Iyer",
      role: "Founder · MealFox (Mumbai)",
      text: "AppFillip pushed our food-delivery app from rank #29 to #3 on Google Play India in three months. Their Hindi + English keyword work is best-in-class.",
    },
    caseStudyFocus: "learning-app-india-aso",
  },

  fr: {
    code: "fr",
    name: "France",
    flag: "🇫🇷",
    shortName: "France",
    locale: "fr_FR",
    currency: "€",
    multiplier: 0.92,
    keyword: "Agence Marketing d'Application France",
    metaTitle:
      "Agence de marketing d'applications en France — Croissance iOS & Android full-stack | AppFillip",
    metaDescription:
      "AppFillip est l'agence de marketing d'applications full-stack pour les apps iOS et Android en France. ASO, acquisition d'utilisateurs, influence, rétention, créatif et analytics — optimisés pour l'App Store et Google Play.",
    keywords:
      "agence marketing application France, ASO France, acquisition d'utilisateurs France, agence app Paris, marketing iOS France, app marketing agency France",
    h1Title: "L'",
    h1Accent: "Agence Marketing d'Application",
    h1Tail: "que les fondateurs français choisissent pour devenir leader de catégorie sur iOS & Android.",
    heroSubtitle:
      "AppFillip est l'agence full-stack de marketing d'applications pour les apps iOS et Android en France. Nous classons, acquérons, convertissons et fidélisons — sur l'App Store, Google Play, Meta, TikTok, Apple Search Ads et Google App Campaigns. De Paris à Lyon, six leviers de croissance, une seule équipe.",
    marketEmphasis: "Full-stack : ASO · UA · Influence · Rétention · Créatif · Analytics",
    trustBadge: "Au service des fondateurs français · Paris → Lyon · Marché premium en Europe",
    verticalFocus: ["Gaming", "FinTech", "Lifestyle"],
    localStat: { value: "8+", label: "Apps françaises classées" },
    editionNotice: {
      label: "Vous consultez l'édition France · localisée pour les fondateurs d'app français",
      switchLabel: "Global",
    },
    testimonial: {
      name: "Camille Bernard",
      role: "Fondatrice · LumiPay (Paris)",
      text: "AppFillip a apporté une vraie expertise ASO en français — pas de traduction automatique. Nos installations sur l'App Store FR ont triplé en deux trimestres.",
    },
    caseStudyFocus: "investment-app-global-aso",
  },

  kr: {
    code: "kr",
    name: "South Korea",
    flag: "🇰🇷",
    shortName: "Korea",
    locale: "ko_KR",
    currency: "₩",
    multiplier: 1350,
    keyword: "앱 마케팅 에이전시 한국",
    metaTitle:
      "앱 마케팅 에이전시 한국 — iOS & Android 풀스택 성장 지원 | AppFillip",
    metaDescription:
      "AppFillip은 한국 iOS & Android 앱을 위한 풀스택 앱 마케팅 에이전시입니다. ASO, 사용자 확보, 인플루언서, 리텐션, 크리에이티브, 분석 — App Store와 Google Play에 최적화. 한국 창업자를 위한 무료 성장 감사 제공.",
    keywords:
      "앱 마케팅 에이전시 한국, 모바일 앱 마케팅 서울, ASO 에이전시 한국, 사용자 획득 한국, 앱 성장 에이전시 부산, iOS 마케팅 한국, Google Play 마케팅 한국, app marketing agency Korea, ASO agency Korea",
    h1Title: "한국",
    h1Accent: "앱 마케팅 에이전시",
    h1Tail: "iOS & Android 앱을 런치부터 카테고리 1위까지 이끄는 파트너.",
    heroSubtitle:
      "AppFillip은 한국 iOS & Android 앱을 위한 풀스택 앱 마케팅 에이전시입니다. App Store, Google Play, Meta, TikTok, Apple Search Ads, Google App Campaigns 전반에 걸쳐 랭킹·확보·전환·리텐션을 제공합니다. 서울부터 부산까지 — 6가지 성장 레버, 한 팀, 한국어 키워드 전략.",
    marketEmphasis: "풀스택: ASO · UA · 인플루언서 · 리텐션 · 크리에이티브 · 분석",
    trustBadge: "한국 앱 창업자 7곳 이상 서비스 · 서울 → 부산 · 세계 4위 앱 시장",
    verticalFocus: ["게임", "FinTech", "엔터테인먼트"],
    localStat: { value: "7+", label: "한국 앱 랭킹 달성" },
    editionNotice: {
      label: "한국판을 보고 계십니다 · 한국 앱 창업자를 위해 현지화됨",
      switchLabel: "글로벌",
    },
    testimonial: {
      name: "김민준",
      role: "창업자 · LoopCast KR (서울)",
      text: "AppFillip은 진짜 한국어 ASO 전문성을 보여줬습니다. Google Play 한국 게임 카테고리에서 Top 10에 오르는 데 8주밖에 걸리지 않았습니다.",
    },
    caseStudyFocus: "casual-game-global-expansion",
  },

  es: {
    code: "es",
    name: "Spain",
    flag: "🇪🇸",
    shortName: "España",
    locale: "es_ES",
    currency: "€",
    multiplier: 0.92,
    keyword: "Agencia de Marketing de Apps España",
    metaTitle:
      "Agencia de marketing de apps en España — Crecimiento iOS y Android full-stack | AppFillip",
    metaDescription:
      "AppFillip es la agencia de marketing de apps full-stack para aplicaciones iOS y Android en España. ASO, adquisición de usuarios, influencer, retención, creatividad y analítica — optimizado para App Store y Google Play.",
    keywords:
      "agencia marketing apps España, ASO España, adquisición de usuarios España, agencia app Madrid, marketing iOS España, app marketing agency Spain",
    h1Title: "La",
    h1Accent: "agencia de marketing de apps",
    h1Tail: "que los fundadores españoles eligen para convertir su app en líder de categoría iOS y Android.",
    heroSubtitle:
      "AppFillip es la agencia full-stack de marketing de apps para aplicaciones iOS y Android en España. Clasificamos, adquirimos, convertimos y fidelizamos — en App Store, Google Play, Meta, TikTok, Apple Search Ads y Google App Campaigns. De Madrid a Barcelona, seis palancas de crecimiento, un solo equipo.",
    marketEmphasis: "Full-stack: ASO · UA · Influencer · Retención · Creativo · Analítica",
    trustBadge: "Al servicio de fundadores españoles · Madrid → Barcelona · Hispanohablantes",
    verticalFocus: ["Gaming", "FinTech", "Lifestyle"],
    localStat: { value: "6+", label: "Apps españolas clasificadas" },
    editionNotice: {
      label: "Estás viendo la edición España · localizada para fundadores de apps españoles",
      switchLabel: "Global",
    },
    testimonial: {
      name: "Carlos Romero",
      role: "Fundador · Bolsa Inteligente (Madrid)",
      text: "AppFillip aportó verdadera experiencia ASO en español — no traducción automática. Nuestras instalaciones en App Store ES se duplicaron en un trimestre.",
    },
    caseStudyFocus: "kids-education-app-organic",
  },

  th: {
    code: "th",
    name: "Thailand",
    flag: "🇹🇭",
    shortName: "Thailand",
    locale: "th_TH",
    currency: "฿",
    multiplier: 36,
    keyword: "เอเจนซี่การตลาดแอป ประเทศไทย",
    metaTitle:
      "เอเจนซี่การตลาดแอปในประเทศไทย — ขับเคลื่อนการเติบโต iOS & Android ครบวงจร | AppFillip",
    metaDescription:
      "AppFillip คือเอเจนซี่การตลาดแอปครบวงจรสำหรับแอป iOS & Android ในประเทศไทย — ASO, การหาผู้ใช้, อินฟลูเอนเซอร์, การรักษาผู้ใช้, ครีเอทีฟ และการวิเคราะห์ บน App Store และ Google Play พร้อมตรวจสุขภาพแอปฟรีสำหรับผู้ก่อตั้งแอปไทย",
    keywords:
      "เอเจนซี่การตลาดแอป ประเทศไทย, การตลาดแอปมือถือ กรุงเทพ, ASO ประเทศไทย, user acquisition ไทย, เอเจนซี่โปรโมทแอป, app marketing agency Thailand, ASO agency Thailand, app growth agency Bangkok, mobile app marketing Thailand",
    h1Title: "ประเทศไทย",
    h1Accent: "เอเจนซี่การตลาดแอป",
    h1Tail: "พาแอป iOS & Android จากวันเปิดตัวสู่อันดับ 1 ของหมวดหมู่",
    heroSubtitle:
      "AppFillip คือเอเจนซี่การตลาดแอปครบวงจรสำหรับแอป iOS & Android ในประเทศไทย เราช่วยให้แอปติดอันดับ หาผู้ใช้ เพิ่มการแปลง และรักษาผู้ใช้ — ทั้งบน App Store, Google Play, Meta, TikTok, Apple Search Ads และ Google App Campaigns จากกรุงเทพถึงเชียงใหม่ — 6 คานงัดการเติบโต ทีมเดียว กลยุทธ์คีย์เวิร์ดภาษาไทย",
    marketEmphasis: "ครบวงจร: ASO · UA · อินฟลูเอนเซอร์ · การรักษาผู้ใช้ · ครีเอทีฟ · การวิเคราะห์",
    trustBadge: "ดูแลผู้ก่อตั้งแอปไทยกว่า 6 ราย · กรุงเทพ → เชียงใหม่ · ตลาดแอปอันดับต้นของอาเซียน",
    verticalFocus: ["FinTech", "อีคอมเมิร์ซ", "เกม"],
    localStat: { value: "6+", label: "แอปไทยที่ติดอันดับ" },
    editionNotice: {
      label: "คุณกำลังดูฉบับประเทศไทย · ปรับให้เหมาะกับผู้ก่อตั้งแอปไทย",
      switchLabel: "สากล",
    },
    testimonial: {
      name: "ณัฐพล ศรีสุวรรณ",
      role: "ผู้ก่อตั้ง · ฟินเทคแอป (กรุงเทพ)",
      text: "AppFillip เข้าใจคีย์เวิร์ดภาษาไทยและพฤติกรรมผู้ใช้ไทยจริง ๆ ภายใน 10 สัปดาห์ แอปของเราขึ้น Top 5 ในหมวดการเงินบน Google Play ไทย",
    },
    caseStudyFocus: "neobank-app-aso-growth",
  },
};

export const MARKET_CODES = Object.keys(MARKETS_CONFIG);
